import { useTranslation } from "@/hooks/useTranslation";
import { useRouteLocale } from "@/hooks/useRouteLocale";
import { usePageMeta } from "@/hooks/usePageMeta";
import { PUBLIC_ROUTES } from "@/routes/public";
import { PublicContentLayout } from "@/components/public/PublicContentLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * JUB-226 / JUB-100: Public Terms & Conditions page including GDPR Art. 28(3)
 * Data Processing Agreement (DPA) clauses, OUG 34/2014 Art. 16 lit. m digital
 * service withdrawal waiver, and ANPC SAL consumer dispute resolution notice.
 */
export default function TermsPage() {
  const { t } = useTranslation();
  const locale = useRouteLocale();

  usePageMeta({
    title: t("termsPage.metaTitle"),
    description: t("termsPage.metaDescription"),
    locale,
    path: PUBLIC_ROUTES.terms(locale),
    alternates: { ro: PUBLIC_ROUTES.terms("ro"), en: PUBLIC_ROUTES.terms("en") },
  });

  return (
    <PublicContentLayout>
      <Card>
        <CardHeader>
          <CardTitle className="text-3xl" data-testid="terms-page-title">{t("termsPage.title")}</CardTitle>
          <CardDescription>{t("termsPage.lastUpdated")}</CardDescription>
        </CardHeader>
        <CardContent className="prose prose-sm max-w-none dark:prose-invert space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-2">{t("termsPage.about.title")}</h2>
            <p>{t("termsPage.about.content")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">{t("termsPage.service.title")}</h2>
            <p>{t("termsPage.service.content")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">{t("termsPage.dpa.title")}</h2>
            <p>{t("termsPage.dpa.content")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">{t("termsPage.payments.title")}</h2>
            <p>{t("termsPage.payments.content")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">{t("termsPage.withdrawal.title")}</h2>
            <p>{t("termsPage.withdrawal.content")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">{t("termsPage.disputes.title")}</h2>
            <p>
              {t("termsPage.disputes.content")}{" "}
              <a
                href="https://reclamatiisal.anpc.ro"
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
                data-testid="terms-anpc-sal-link"
              >
                ANPC SAL (reclamatiisal.anpc.ro)
              </a>
              .
            </p>
          </section>
        </CardContent>
      </Card>
    </PublicContentLayout>
  );
}
